
import { useState, useEffect } from 'react';

// Simple time sync hook - can be enhanced later
export function useTimeSync() {
  const [isTimeSynced, setIsTimeSynced] = useState(true);

  useEffect(() => {
    // For now, assume time is always synced
    // This can be enhanced with actual server time synchronization
    setIsTimeSynced(true);
  }, []);

  return { isTimeSynced };
}
